var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-container"},[_c('img',{staticClass:"responsive-image",attrs:{"src":this.imgSrc}})])
}
var staticRenderFns = []

export { render, staticRenderFns }